import React, { Component, ReactChildren } from 'react';
import { errorAlert } from '../util/helperFunctions';
import api from '../util/api';
import * as Sentry from '@sentry/browser';

const PatioRuleContext = React.createContext({
  patioRules: null,
});

export class PatioRuleProvider extends Component<{ children: ReactChildren | (JSX.Element | JSX.Element[])[] }> {
  state = {
    patioRules: null,
  };

  handleError = () => {
    errorAlert(
      '',
      `It looks like we're having some trouble connecting to the internet. Try refreshing the page. If this problem persists, please contact your supervisor.`,
    );
  };

  async componentDidMount() {
    try {
      const { content } = await api.customContent.getOne('patio_rules');
      this.setState({
        patioRules: content,
      });
    } catch (err) {
      console.error(err);
      this.handleError();
      Sentry.captureException(err);
    }
  }

  render() {
    const { children } = this.props;

    return <PatioRuleContext.Provider value={this.state}>{children}</PatioRuleContext.Provider>;
  }
}

export const PatioRuleContextConsumer = PatioRuleContext.Consumer;
